// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"ImageFile__pc_only___v0z09","sp_only":"ImageFile__sp_only___1VfwI","image_file":"ImageFile__image_file___2zkGR"};